export const EXPORT_TOP_FLOP_DEFAULT_SORT_KPI = {
    amount: 'sales_amount',
    quantity: 'sales_quantity'
};
//# sourceMappingURL=exportTopFlopDefaultSortKpi.constant.js.map